import React from 'react';
import {Link} from 'react-router-dom';
import HomeOneAboutImg1 from '../../assets/images/about/club4.jpg';
import HomeOneAboutImg2 from '../../assets/images/about/club222.jpg';
import { FaLocationArrow } from 'react-icons/fa';

const HomeOneAbout = () => {
    return (
        <div className="about-area white-bg pt-105 pb-105">
            <div className="container">
                <div className="row d-flex align-items-center">
                    <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="about-text-wrapper mb-30">
                            <div className="section-title mr-30 mb-40">
                                <h2>Έκπτωση 10% για παραλαβή από το κατάστημά μας </h2>
                            </div>
                            <a href="https://maps.app.goo.gl/tXY9qd8i2Xv93YiJA" target="_blank" className="l-btn"><FaLocationArrow />  ΒΡΕΙΤΕ ΜΑΣ ΕΔΩ</a>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6">
                        <div className="about-wrapper-style-1 mb-30">
                            <img className="rounded" src={HomeOneAboutImg1} alt="About Us" />
                            <img className="about-secondary rounded" src={HomeOneAboutImg2} alt="About Us" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeOneAbout;